import React from 'react';
type EmojiProps = {
  symbol: string;
  label?: string;
  className?: string;
};

/**
 * Renders an emoji as a colorful 3D-style image instead of the flat system glyph.
 */
export function Emoji({
  symbol,
  label,
  className = ''
}: EmojiProps) {
  return <img src={`https://emojicdn.elk.sh/${encodeURIComponent(symbol)}?style=apple`} alt={label ?? ''} aria-hidden={label ? undefined : true} loading="lazy" className={['inline-block h-[1.15em] w-[1.15em] shrink-0 select-none align-[-0.2em] drop-shadow-[0_2px_3px_rgba(0,0,0,0.35)]', className].join(' ')} data-id="element-75" data-mp="3tc6075ygqa3b" />;
}